// app/javascript/controllers/dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]
  
  static classes = ["open", "closed"]  // ✅ Configurable

  connect() {
    console.log("⬇️ Dropdown controller connected")
    
    // ✅ FIX #1: Bind ONCE and store reference
    this.boundHideOnOutsideClick = this.hideOnOutsideClick.bind(this)
    
    // ✅ Initial state
    this.isOpen = false
  }

  toggle(event) {
    event?.stopPropagation()
    
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }
  
  open() {
    clearTimeout(this.fermeture)
    this.menuTarget.classList.remove('hidden')
    if (this.anime) {
      // Lire la géométrie force le navigateur à peindre l'état fermé d'abord :
      // sans ça, `hidden` et l'état ouvert tombent dans la même image et la
      // transition ne joue pas.
      this.menuTarget.getBoundingClientRect()
      this.menuTarget.dataset.ouvert = ""
    }
    this.isOpen = true
    
    // ✅ Update ARIA
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', 'true')
    }
    
    // ✅ FIX #2: Add listener ONLY when open
    // Use setTimeout to prevent immediate close on same click
    setTimeout(() => {
      document.addEventListener('click', this.boundHideOnOutsideClick)
    }, 0)
    
    console.log("⬇️ Dropdown opened")
  }

  close() {
    this.isOpen = false
    if (this.anime) {
      // La sortie joue d'abord, `hidden` tombe à la fin. Le minuteur couvre le
      // cas où transitionend ne vient pas (onglet en arrière-plan) ; et une
      // réouverture pendant la sortie annule tout (clearTimeout dans open).
      delete this.menuTarget.dataset.ouvert
      const cacher = () => { if (!this.isOpen) this.menuTarget.classList.add('hidden') }
      this.menuTarget.addEventListener('transitionend', cacher, { once: true })
      clearTimeout(this.fermeture)
      this.fermeture = setTimeout(cacher, 250)
    } else {
      this.menuTarget.classList.add('hidden')
    }
    
    // ✅ Update ARIA
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', 'false')
    }
    
    // ✅ FIX #3: Remove listener when closed
    document.removeEventListener('click', this.boundHideOnOutsideClick)
    
    console.log("⬇️ Dropdown closed")
  }
  
  // ✅ Alias for backwards compatibility
  hide() {
    this.close()
  }

  hideOnOutsideClick(event) {
    // Don't close if clicking inside dropdown
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
  
  // ✅ NEW: Keyboard support (Escape to close)
  handleKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      event.preventDefault()
      this.close()
      
      // Return focus to toggle button
      if (this.hasButtonTarget) {
        this.buttonTarget.focus()
      }
    }
  }

  // ✅ FIX #4: CRITICAL cleanup
  // Animé seulement si le menu le demande (classe .menu-deroulant) : les
  // autres menus qui utilisent ce contrôleur gardent leur comportement.
  get anime() {
    return this.menuTarget.classList.contains('menu-deroulant')
  }

  disconnect() {
    clearTimeout(this.fermeture)
    document.removeEventListener('click', this.boundHideOnOutsideClick)
    console.log("⬇️ Dropdown controller disconnected")
  }
}
